import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  const inputs: Record<string, InputType> = {}
  inputs['divider'] = {
    inputType: 'custom',
    title: '',
    visible: true,
  }
  inputs['adminEmailDns'] = {
    inputType: 'text',
    title: 'Email DNS of Administrator',
    required: false,
    visible: true,
  }
  return inputs
}
